// "From" for a lead email: the sales address, or the signed-in user personally. Used by the lead agent's drafts and
// the deal email panel; the starting value comes from senderFor (senior titles go personal) and can be changed.
import { useGetIdentity, useTranslate } from "ra-core";

import { useConfigurationContext } from "../../root/ConfigurationContext";
import { DEFAULT_SEND_AS, SENDERS, type Sender } from "./outlook";

export const SenderSelect = ({
  value,
  onChange,
  disabled,
  title,
}: {
  value: Sender;
  onChange: (sender: Sender) => void;
  disabled?: boolean;
  title?: string;
}) => {
  const translate = useTranslate();
  const config = useConfigurationContext();
  const { identity } = useGetIdentity();
  const sendAs = config.outlook_send_as || DEFAULT_SEND_AS;
  return (
    // min-w-0: a long address truncates instead of widening a narrow panel (the pre-lead drawer)
    <label className="flex min-w-0 max-w-full items-center gap-2 text-sm">
      <span className="shrink-0 text-muted-foreground">
        {translate("resources.leads.agent.from")}
      </span>
      <select
        className="h-9 min-w-0 flex-1 truncate rounded-md border bg-transparent px-2 text-sm"
        value={value}
        disabled={disabled}
        title={title}
        onChange={(e) => onChange(e.target.value as Sender)}
      >
        {SENDERS.map((sender) => (
          <option key={sender} value={sender}>
            {translate(`resources.leads.agent.senders.${sender}`, {
              address: sendAs,
              name: identity?.fullName ?? "",
            })}
          </option>
        ))}
      </select>
    </label>
  );
};
